import React, {useState} from 'react';
import s from '../MyOrdersForManager.module.css';
import TableButtonsActions, {
	ActionConfig,
} from '../../../Components/TableButtonsActions/TableButtonsActions';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import act02 from '../../../assets/img/icons/actions/actioms02.svg';
import act03 from '../../../assets/img/icons/actions/actioms03.svg';
import act04 from '../../../assets/img/icons/actions/actioms04.svg';
import pay from '../../../assets/img/icons/actions/action01.svg';
import infoButton from '../../../assets/img/icons/actions/info.svg';
import {OrderInfo} from '../../../types/TypesUserOrders';
import {
	useDeleteUserOrderMutation,
	useLazyOrderInfoQuery,
} from '../../../redux/userOrdersApi';
import {generateOrderPDF} from '../../../utils/pdfGenerator';
import {handleApiCall} from '../../../assets/utils/utils';
import PopupManagerInfo from '../MyOrdersPopups/Info/PopupManagerInfo';
import PopupManagerEdit from '../MyOrdersPopups/Edit/PopupManagerEdit';
type Props = {
	order: OrderInfo;
};
const OrdersActions: React.FC<Props> = ({order}) => {
	const {t} = useTranslation();
	const navigate = useNavigate();

	const [openInfoPopup, setOpenInfoPopup] = useState<boolean>(false);
	const [openEditPopup, setOpenEditPopup] = useState<boolean>(false);
	const [deleteOrder] = useDeleteUserOrderMutation();
	const [trigger, {data, isLoading}] = useLazyOrderInfoQuery();
	// === HANDLERS ===
	const handlers = {
		delete: async (id: number) => {
			await handleApiCall({
				apiCall: () => deleteOrder(id),
			});
		},
		edit: async (id: number) => {
			await handleApiCall({
				apiCall: () => trigger(id),
				onSuccess: () => setOpenEditPopup(true),
			});
		},
		print: async () => {
			try {
				console.log('Order data before PDF generation:', order);
				await generateOrderPDF(order);
			} catch (error) {
				console.error('Ошибка генерации PDF:', error);
			}
		},
		pay: (id: number) => {
			console.log(id);
		},
		info: async (id: number) => {
			await handleApiCall({
				apiCall: () => trigger(id),
				onSuccess: () => setOpenInfoPopup(true),
			});
		},
	};

	const actions: ActionConfig[] = [
		{
			type: 'pay',
			icon: pay,
			label: t('Оплатити'),
			disabled: () => true,
			requiresConfirmation: false,
			confirmText: t('Ви дійсно хочете оплатити замовлення?'),
			handler: handlers.pay,
		},
		{
			type: 'delete',
			icon: act02,
			label: t('Видалити'),
			disabled: () =>
				!(order.status === 'created' || order.status === 'confirmed'),
			requiresConfirmation: true,
			confirmText: t('Ви дійсно хочете видалити замовлення?'),
			handler: handlers.delete,
		},
		{
			type: 'edit',
			icon: act03,
			label: t('Редагувати'),
			disabled: () =>
				!(order.status === 'created' || order.status === 'confirmed'),
			handler: handlers.edit,
		},
		{
			type: 'print',
			icon: act04,
			label: t('Друк'),
			handler: handlers.print,
		},
		{
			type: 'info',
			icon: infoButton,
			label: t('Інфо'),
			handler: handlers.info,
		},
	];

	const handleClosePopup = () => {
		setOpenInfoPopup(false);
	};
	const handleCloseEditPopup = () => {
		setOpenEditPopup(false);
	};

	return (
		<div className={s.actions}>
			{openInfoPopup && !isLoading && data && (
				<PopupManagerInfo orderInfo={data} close={handleClosePopup} />
			)}
			{openEditPopup && !isLoading && data && (
				<PopupManagerEdit
					orderId={order.id}
					orderInfo={data}
					close={handleCloseEditPopup}
				/>
			)}
			<div>
				<TableButtonsActions
					actions={actions}
					orderId={order.id}
					orderStatus={order.status}
				/>
			</div>
		</div>
	);
};

export default OrdersActions;
